// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

interface CategoryListingStyles {
    container?: InjectableCss;
    rightBorderedCategoryListItem?: InjectableCss;
}

const borderStyle = css`
    border-right: 1px solid ${color("common.border")};
    padding-right: 10px;
    margin-right: 10px;
`;
const nonBorderStyle = css`
    border-right: none;
    padding-right: 0;
    margin-right: 0;
`;

const categoryListingStyles: CategoryListingStyles = {
    container: {
        css: css`
            display: grid;
            justify-items: stretch;
            row-gap: 48px;
            grid-template-columns: repeat(6, 1fr);

            ${xScreen("lte", "md")} {
                grid-template-columns: repeat(4, 1fr);
            }

            ${xScreen("lte", "sm")} {
                grid-template-columns: repeat(3, 1fr);
                column-gap: 20px;
                row-gap: 24px;
            }

            ${xScreen("lte", "xs")} {
                grid-template-columns: repeat(2, 1fr);
                column-gap: 16px;
            }

            ${xScreen("lt", 360)} {
                grid-template-columns: repeat(1, 1fr);
            }
        `,
    },
    rightBorderedCategoryListItem: {
        css: css`
            &:not(:last-child):not(:nth-child(6n)) {
                ${borderStyle}
            }

            ${xScreen("lte", "md")} {
                &&:nth-child(6n) {
                    ${borderStyle}
                }
                &&:not(:last-child):nth-child(4n) {
                    ${nonBorderStyle}
                }
            }
            ${xScreen("lte", "sm")} {
                &&& {
                    ${nonBorderStyle}
                }
            }
        `,
    },
};

export default categoryListingStyles;
